import { Scale, Gavel, ShieldCheck, Building2, Heart } from "lucide-react";
import { useContent } from "@/i18n";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const ICONS = { civil: Scale, criminal: Gavel, cyber: ShieldCheck, corporate: Building2, matrimonial: Heart };
const SPANS = ["lg:col-span-6", "lg:col-span-6", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4"];

export const PracticeAreas = () => {
  const { t } = useContent();
  return (
    <section id="practice" data-testid="practice-section" className="relative bg-paper py-28 text-navy-900 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <SectionHeading light eyebrow={t.practice.eyebrow} title={t.practice.title} intro={t.practice.intro} />
        <ul className="mt-20 grid gap-px bg-navy-900/10 lg:grid-cols-12" data-testid="practice-grid">
          {t.practice.areas.map((a, i) => {
            const Icon = ICONS[a.id];
            return (
              <Reveal key={a.id} delay={0.08 * i} as="li" className={`col-span-1 ${SPANS[i]}`}>
                <div
                  data-testid={`practice-card-${a.id}`}
                  className="group relative flex h-full flex-col bg-paper p-8 transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-white md:p-12"
                >
                  <div className="flex items-start justify-between">
                    <span className="font-mono text-xs tracking-[0.3em] text-gold">{a.code}</span>
                    <Icon size={26} strokeWidth={1.2} className="text-navy-900/60 transition-colors duration-500 group-hover:text-gold" aria-hidden="true" />
                  </div>
                  <div className="mt-14 flex-1">
                    <h3 className="font-serif text-3xl font-light tracking-tight sm:text-4xl">{a.title}</h3>
                    <p className="mt-5 max-w-md text-base leading-relaxed text-navy-700/80">{a.body}</p>
                  </div>
                  <div className="mt-10 border-t border-navy-900/10 pt-4">
                    <p className="min-h-[4rem] font-mono text-[10px] uppercase leading-[1.6] tracking-[0.2em] text-navy-700/60">
                      {a.statutes}
                    </p>
                  </div>
                  <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-0 bg-gold transition-[width] duration-700 ease-out group-hover:w-full" />
                </div>
              </Reveal>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
